"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_helmet_1 = require("react-helmet");
var antd_1 = require("antd");
require("antd/lib/result/style");
var react_router_dom_1 = require("react-router-dom");
var SystemLogout = function () {
    var history = react_router_dom_1.useHistory();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.Helmet, { title: "Logout successful" }),
        react_1.default.createElement(antd_1.Result, { status: "success", title: "Logout successful", subTitle: "You have been logged out. See you soon!", extra: [
                react_1.default.createElement(antd_1.Button, { key: "login", onClick: function () { return history.push('/login'); } }, "Login again"),
            ] })));
};
exports.default = {
    name: 'Logout',
    routeProps: {
        path: '/logout_successful',
        component: SystemLogout,
    },
};
//# sourceMappingURL=index.js.map